import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 0),
    marginTop: 'auto',
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  footerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
  },
  links: {
    display: 'flex',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
    },
  },
  link: {
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  copyright: {
    color: theme.palette.text.secondary,
  },
}))

const Footer = () => {
  const classes = useStyles()

  const handleTermsClick = () => {
    window.open('/terms-and-conditions.html', '_blank')
  }

  const handlePrivacyClick = () => {
    window.open('/privacy-policy.html', '_blank')
  }

  return (
    <footer className={classes.footer}>
      <Box className={classes.footerContent}>
        <Typography variant="body2" className={classes.copyright}>
          © {new Date().getFullYear()} EfficienseeAI. All rights reserved.
        </Typography>
        <div className={classes.links}>
          <Link
            component="button"
            variant="body2"
            className={classes.link}
            onClick={handleTermsClick}
          >
            Terms & Conditions
          </Link>
          <Link
            component="button"
            variant="body2"
            className={classes.link}
            onClick={handlePrivacyClick}
          >
            Privacy Policy
          </Link>
        </div>
      </Box>
    </footer>
  )
}

export default Footer
